export default __webpack_public_path__ + "static/media/phonepe.95bffa80.webp";